import React, { useState, useEffect } from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, } from "@mui/material";

import { updateSLTPOrders, deleteSLTPOrders, modifyPositionSLTP } from "../../api/request/dashboard/dashboard";
import toast from 'react-hot-toast';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { editSLTPOrder, deleteSLTPOrder, addSLTPOrder } from "../../store/Slices/orderPositionSlice";
import { DeleteOutline, EditOutlined } from '@mui/icons-material'
import { useTranslation } from "react-i18next";
import { addJournalLog } from '../../components/tab/tabview/journal/addJournalLog';
import { getCookies } from "../../services/Cookies";
import AddEditModal from "../../components/modal/EditSLTP/AddEditModal";

const initForm = { amount: "", st: "", tp: "" }
const Sltp = ({ editSLTP }) => {
    const [selectedSLTP, setSelectedSLTP] = useState(null);
    const [isOpenEdit, setIsOpenEdit] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [formData, setFormData] = useState(initForm);
    const dispatch = useDispatch()
    const sltpArray = Array.isArray(editSLTP) ? editSLTP : editSLTP ? [editSLTP] : [];
    const symbol = useSelector(state => state.updateSymbol.symbols?.[editSLTP[0].symbolId])
    const decimalPlaces = 2;
    const { t } = useTranslation()
    const positions = useSelector((state) => state.orderPosition.positions, shallowEqual);
    const selectedPositionId = sltpArray[0]?.positionId;
    const selectedPosition = positions.find(pos => pos.id === selectedPositionId);
    const totalAmount = sltpArray.reduce((sum, item) => sum + item.amount, 0);
    const username = getCookies('username')

    // const maxAmount = parseFloat((selectedPosition?.amount - totalAmount).toFixed(decimalPlaces));
    const maxAmount = isEdit
        ? Number((selectedPosition?.amount ?? 0).toFixed(decimalPlaces))
        : Number(((selectedPosition?.amount ?? 0) - (totalAmount ?? 0)).toFixed(decimalPlaces));


    useEffect(() => {
        setFormData({
            amount: selectedSLTP?.amount || "",
            st: selectedSLTP?.stopLoss || "",
            tp: selectedSLTP?.takeProfit || ""
        });
    }, [selectedSLTP]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "amount" && Number(value) > maxAmount) {
            toast.error(`Amount cannot exceed ${maxAmount}`);
            return;
        }
        if (maxAmount === 0) {
            toast.error("All lots are managed.");
            return;
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleEdit = async () => {
        if (!selectedSLTP) return toast.error("No order selected");

        const updatedOrder = {
            id: selectedSLTP.id,
            amount: formData.amount,
            stopLoss: formData.st,
            takeProfit: formData.tp,
            accountId: selectedSLTP.accountId
        };

        try {
            const response = await updateSLTPOrders(updatedOrder);
            dispatch(editSLTPOrder(response));
            // toast.success("SLTP updated successfully");
            setIsOpenEdit(false)
        } catch (error) {
            toast.error("Failed to update order");
        }
    };

    const handlePlaceOrder = async () => {
        if (!editSLTP) return toast.error("No order selected");

        const selectedOrder = editSLTP[0]
        const newOrder = {
            accountId: selectedOrder.accountId,
            positionId: selectedOrder.positionId,
            amount: Number(formData.amount),
            // stopLoss: Number(formData.st),
            // takeProfit: Number(formData.tp)
        };
        if (formData.st !== "" && formData.st !== null && formData.st !== undefined) {
            newOrder.stopLoss = Number(formData.st);
        }

        if (formData.tp !== "" && formData.tp !== null && formData.tp !== undefined) {
            newOrder.takeProfit = Number(formData.tp);
        }

        try {
            const response = await modifyPositionSLTP(newOrder);
            dispatch(addSLTPOrder(response));
            // toast.success("New SLTP order placed successfully");
        } catch (error) {
            console.error("Error placing SLTP order:", error);
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to place SLTP order";
            toast.error(errorMessage);
        }

    };

    const handleDelete = async (sltp) => {
        if (!sltp) return toast.error("No SLTP selected");

        try {
            const data = {
                accountId: sltp.accountId,
                id: sltp.id
            };
            await deleteSLTPOrders(data);
            dispatch(deleteSLTPOrder(sltp.id));
            // toast.success("SLTP deleted successfully");
        } catch (error) {
            addJournalLog('deleteManageOrderError', `Delete Pending order: #${selectedPosition.id} failure: ${error}, Account ${username}: ${sltp.accountId}.`);
            toast.error("Failed to delete SLTP", error);
        }
    };


    useEffect(() => {
        if (!isOpenEdit) {
            setisEdit(false);
        }
    }, [isOpenEdit])

    const handleAddNewSLTP = () => {
        if (maxAmount === 0) {
            toast.error("All lots are managed.");
            return;
        }
        setIsOpenEdit(true);
        setFormData(initForm);
        setisEdit(false);
    };
    return (
        <>
            <Box sx={{ padding: 0}} >
                {sltpArray.length > 0 ? (
                    <Box sx={{ maxHeight: 200, overflowY: "auto", mb: 2 }}>
                        <TableContainer component={Paper} sx={{ mt: 2, mb: 2, border: "1px solid #c6c6c6", borderRadius: 1 }}>
                            <Table size="small" sx={{ minWidth: 250, borderCollapse: "collapse" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{fontSize:12}} align="center">{t('amount')}</TableCell>
                                        <TableCell sx={{fontSize:12}} align="center">{t('s/l')}</TableCell>
                                        <TableCell sx={{fontSize:12}} align="center">{t('t/p')}</TableCell>
                                        <TableCell sx={{fontSize:12}} align="center">{t('action')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sltpArray.map((sltp, index) => (
                                        <TableRow key={index} hover sx={{ cursor: "pointer" }}>
                                            <TableCell align="center" sx={{ fontSize: 13, width: "20%" }}> {Number(sltp.amount).toFixed(decimalPlaces)} </TableCell>
                                            <TableCell align="center" sx={{ fontSize: 13, width: "20%" }}> {Number(sltp.stopLoss ?? 0).toFixed(symbol.digits)} </TableCell>
                                            <TableCell align="center" sx={{ fontSize: 13, width: "20%" }}> {Number(sltp.takeProfit ?? 0).toFixed(symbol.digits)} </TableCell>
                                            <TableCell align="center" sx={{ fontSize: 13, color: "#da5244", width: "20%", "& .MuiSvgIcon-root": { fontSize: 17, } }} ><DeleteOutline onClick={e => { setSelectedSLTP(sltp); handleDelete(sltp) }} /> <EditOutlined onClick={e => { setSelectedSLTP(sltp); setIsOpenEdit(true); setisEdit(true); }} /> </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                ) : null}
            </Box>
            {isOpenEdit && <AddEditModal sltpArray={sltpArray} sltp={sltpArray?.[0] || {}} isOpenEdit={isOpenEdit} setIsOpenEdit={setIsOpenEdit} isEdit={isEdit} formData={formData} handleChange={handleChange} handleEdit={handleEdit} handlePlaceOrder={handlePlaceOrder} />}
        </>
    );

};

export default Sltp;
